// Plain-language messages for sign-in problems, shared by the sign-in and sign-up pages.
// None of them suggests creating a second account: one email address is one SoapLab account,
// whether it signs in with Google or with a password.

export function googleSignInMessage(error) {
  switch (error?.code) {
    case 'auth/in-app-browser':
      return error.message;
    case 'auth/popup-blocked':
      return 'Your browser blocked the Google window. Allow pop-ups for soaplab.in, then try again.';
    case 'auth/account-exists-with-different-credential':
      return 'This email already has a SoapLab account with a password. Sign in with your email and password; you can then connect Google in Settings.';
    case 'auth/network-request-failed':
      return 'There is no internet connection. Check your connection and try again.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact support.';
    case 'auth/unauthorized-domain':
    case 'auth/operation-not-allowed':
      return 'Google sign-in is not available right now. Please contact support.';
    default:
      return 'Google sign-in didn’t finish. Please try again.';
  }
}

export function emailSignInMessage(error) {
  switch (error?.code) {
    case 'auth/invalid-credential':
    case 'auth/invalid-login-credentials':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
      return 'Email or password is incorrect. If you joined with Google, use “Continue with Google” instead.';
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a few minutes and try again, or reset your password.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact support.';
    case 'auth/network-request-failed':
      return 'There is no internet connection. Check your connection and try again.';
    default:
      return 'Could not sign in. Please try again.';
  }
}
